import { setGetListEventsAction } from '../action';
import { getListEvents } from '../api/getListEvents';
import { setLoadingAction } from '../../../components/templatePage/store/action';

const setGetListEvents = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getListEvents(params);

            if (data.status === 'success') {
                const events = [...getState().adminMobile.events.data];
                events.push(data.data);
    
                dispatch(setGetListEventsAction({
                    data: events.flat(1),
                    countPage: data.countPage
                }));
                dispatch(setLoadingAction(false))
            }

        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetListEvents
}